<button type="button" (click)="refresh.emit()" placement="top" triggers="mouseenter:mouseleave" ngbPopover="Refresh"
  class="btn btn-outline-primary btn-circle" [disabled]="disabled"><i class="link-icon feather icon-refresh-cw"></i>
</button>